import {isNumeric} from "@/functions/tools";
import getBrandName from "@/functions/getBrandName";
import getAppYear from "@/functions/getAppYear";

// OLD METHOD. Update to only show default if a valid message comes through that was missed when switching to new method.
const MESSAGE_1 = {
	id: 1,
	type: "WARNING",
	title: "",
	message: "There was a problem, please try again. If the problem continues please contact support.",
	isRedirectToLogin: false
};

const MESSAGE_2 = {
	id: 2,
	type: "WARNING",
	title: `You can no longer sign in to your account for the ${Number(process.env.VUE_APP_MIN_PRIOR_TAX_YEAR) - 1} tax year or earlier.`,
	get message() {
		return `Please sign in to your account for the <a href="https://${process.env.VUE_APP_AUTH_SUBDOMAIN}.${getBrandName()}.com?appYear=${process.env.VUE_APP_CURRENT_TAX_YEAR}">${process.env.VUE_APP_CURRENT_TAX_YEAR} tax year</a>.`
	},
	isRedirectToLogin: false
};

const MESSAGE_3 = {
	id: 3,
	type: "INFO",
	title: "Already Signed In",
	message: "We noticed you were already signed in elsewhere, so we safely signed you out.<br><br>Please sign back in to your account now.",
	isRedirectToLogin: false
};

const MESSAGE_4 = {
	id: 4,
	type: "WARNING",
	title: "There was a problem, please try again. If the problem continues please contact support.",
	message: "Return to the original device you were filing on to continue.",
	isRedirectToLogin: false
};

const MESSAGE_5 = {
	id: 5,
	type: "WARNING",
	title: "Session Ended",
	message: "Your session has timed out or ended. Please sign in to continue.",
	isRedirectToLogin: false
};

const MESSAGE_6 = {
	id: 6,
	type: "INFO",
	title: "",
	message: "You're safely signed out.",
	isRedirectToLogin: false
};

const MESSAGE_7 = {
	id: 7,
	type: "ERROR",
	title: "Can't Change Tax Return to Another Website",
	get message() {
		return `You filed your tax return on a website other than ${getBrandName()}.com, and it either has been accepted or is being processed.<br><br><b>You can't switch your return to another website at this time.`
	},
	isRedirectToLogin: false
};

// NEW METHOD
const messages = [
	{
		id: 1,
		content: {
			type: "WARNING",
			title: "",
			message: "There was a problem, please try again. If the problem continues please contact support.",
			isRedirectToLogin: false
		}
	},
	{
		id: 2,
		content: {
			type: "WARNING",
			title: `You can no longer sign in to your account for the ${Number(process.env.VUE_APP_MIN_PRIOR_TAX_YEAR) - 1} tax year or earlier.`,
			get message() {
				return `Please sign in to your account for the <a href="https://${process.env.VUE_APP_AUTH_SUBDOMAIN}.${getBrandName()}.com?appYear=${process.env.VUE_APP_CURRENT_TAX_YEAR}">${process.env.VUE_APP_CURRENT_TAX_YEAR} tax year</a>.`
			},
			isRedirectToLogin: false
		}
	},
	{
		id: 3,
		content: {
			type: "INFO",
			title: "Already Signed In",
			message: "We noticed you were already signed in elsewhere, so we safely signed you out.<br><br>Please sign back in to your account now.",
			isRedirectToLogin: false
		}
	},
	{
		id: 4,
		content: {
			type: "WARNING",
			title: "There was a problem, please try again. If the problem continues please contact support.",
			message: "Return to the original device you were filing on to continue.",
			isRedirectToLogin: false
		}
	},
	{
		id: 5,
		content: {
			type: "WARNING",
			title: "Session Ended",
			message: "Your session has timed out or ended. Please sign in to continue.",
			isRedirectToLogin: false
		}
	},
	{
		id: 6,
		content: {
			type: "INFO",
			title: "",
			message: "You're safely signed out.",
			isRedirectToLogin: false
		}
	},
	{
		id: 7,
		content: {
			type: "ERROR",
			title: "Can't Change Tax Return to Another Website",
			get message() {
				return `You filed your tax return on a website other than ${getBrandName()}.com, and it either has been accepted or is being processed.<br><br><b>You can't switch your return to another website at this time.`
			},
			isRedirectToLogin: false
		}
	},
	{
		id: 8,
		content: {
			type: "WARNING",
			title: "",
			get message() {
				return `You recently started importing a PDF of your ${getAppYear() - 1} tax return on this account, and it hasn't finished yet. Please wait a minute or two and then sign in again.`
			},
			isRedirectToLogin: false
		}
	},
	{
		id: 9,
		content: {
			type: "WARNING",
			title: "",
			message: "You recently submitted your tax return on this account, but it hasn't gone through yet. Please wait a minute or two and then sign in again.",
			isRedirectToLogin: false
		}
	},
	{
		id: 10,
		content: {
			type: "INFO",
			title: "",
			get message() {
				return `Please sign in to the <a href="https://${process.env.VUE_APP_PREPARER_SUBDOMAIN}.${getBrandName().toLowerCase()}.com">preparer portal</a> to manage your client accounts.`
			},
			isRedirectToLogin: false
		}
	},
	{
		id: 11,
		content: {
			type: "ERROR",
			title: "",
			message: "Authentication failed; please try again.",
			isRedirectToLogin: false
		}
	},
	{
		id: 12,
		content: {
			type: "ERROR",
			title: "Account Locked",
			message: "Your account has been locked for security. Please contact support to unlock it.",
			isRedirectToLogin: false
		}
	},
	{
		id: 13,
		content: {
			type: "INFO",
			title: "",
			message: "Your account was already created. Please sign in.",
			isRedirectToLogin: false
		}
	}
];

const mappingTitles = {
	"You can no longer sign in to your account": MESSAGE_2,
	"Already signed in": MESSAGE_3,
	"There was a problem, please try again.": MESSAGE_4,
	"Session ended": MESSAGE_5,
	"Can't Change Tax Return to Another Website": MESSAGE_7
}

const mappingMessages = {
	"There was a problem, please try again.": MESSAGE_1,
	"You're safely signed out.": MESSAGE_6
}

// const base64EncodeTestString = W3sidHlwZSI6IldBUk5JTkciLCJ0aXRsZSI6IiIsIm1lc3NhZ2UiOiJUaGVyZSB3YXMgYSBwcm9ibGVtLCBwbGVhc2UgdHJ5IGFnYWluLiBJZiB0aGUgcHJvYmxlbSBjb250aW51ZXMgcGxlYXNlIGNvbnRhY3Qgc3VwcG9ydC4iLCJpc1JlZGlyZWN0VG9Mb2dpbiI6ZmFsc2V9LHsidHlwZSI6IklORk8iLCJ0aXRsZSI6IkFscmVhZHkgU2lnbmVkIEluIiwibWVzc2FnZSI6IldlIG5vdGljZWQgeW91IHdlcmUgYWxyZWFkeSBzaWduZWQgaW4gZWxzZXdoZXJlLCBzbyB3ZSBzYWZlbHkgc2lnbmVkIHlvdSBvdXQuPGJyPjxicj5QbGVhc2Ugc2lnbiBiYWNrIGluIHRvIHlvdXIgYWNjb3VudCBub3cuIiwiaXNSZWRpcmVjdFRvTG9naW4iOmZhbHNlfSx7InR5cGUiOiJXQVJOSU5HIiwidGl0bGUiOiJUaGVyZSB3YXMgYSBwcm9ibGVtLCBwbGVhc2UgdHJ5IGFnYWluLiBJZiB0aGUgcHJvYmxlbSBjb250aW51ZXMgcGxlYXNlIGNvbnRhY3Qgc3VwcG9ydC4iLCJtZXNzYWdlIjoiUmV0dXJuIHRvIHRoZSBvcmlnaW5hbCBkZXZpY2UgeW91IHdlcmUgZmlsaW5nIG9uIHRvIGNvbnRpbnVlLiIsImlzUmVkaXJlY3RUb0xvZ2luIjpmYWxzZX0seyJ0eXBlIjoiSU5GTyIsInRpdGxlIjoiIiwibWVzc2FnZSI6IjxpbWcgc3JjPXggb25lcnJvcj0nYWxlcnQoZG9jdW1lbnQuZG9tYWluKSc+PC9pbWc+LiIsImlzUmVkaXJlY3RUb0xvZ2luIjpmYWxzZX0seyJ0eXBlIjoiV0FSTklORyIsInRpdGxlIjoiU2Vzc2lvbiBFbmRlZCIsIm1lc3NhZ2UiOiJZb3VyIHNlc3Npb24gaGFzIHRpbWVkIG91dCBvciBlbmRlZC4gUGxlYXNlIHNpZ24gaW4gdG8gY29udGludWUuIiwiaXNSZWRpcmVjdFRvTG9naW4iOmZhbHNlfSx7InR5cGUiOiJJTkZPIiwidGl0bGUiOiIiLCJtZXNzYWdlIjoiWW91J3JlIHNhZmVseSBzaWduZWQgb3V0LiIsImlzUmVkaXJlY3RUb0xvZ2luIjpmYWxzZX0seyJ0eXBlIjoiV0FSTklORyIsInRpdGxlIjoiWW91IGNhbiBubyBsb25nZXIgc2lnbiBpbiB0byB5b3VyIGFjY291bnQgZm9yIHRoZSAyMDE1IHRheCB5ZWFyIG9yIGVhcmxpZXIuIiwibWVzc2FnZSI6IlBsZWFzZSBzaWduIGluIHRvIHlvdXIgYWNjb3VudCBmb3IgdGhlIDxhIGhyZWY9XCJodHRwczovL2F1dGguZnJlZXRheHVzYS5jb20/YXBwWWVhcj0yMDI0XCI+MjAyNSB0YXggeWVhcjwvYT4uIiwiaXNSZWRpcmVjdFRvTG9naW4iOmZhbHNlfSx7InR5cGUiOiJFUlJPUiIsInRpdGxlIjoiQ2FuJ3QgQ2hhbmdlIFRheCBSZXR1cm4gdG8gQW5vdGhlciBXZWJzaXRlIiwibWVzc2FnZSI6IllvdSBmaWxlZCB5b3VyIHRheCByZXR1cm4gb24gYSB3ZWJzaXRlIG90aGVyIHRoYW4gRnJlZVRheFVTQS5jb20sIGFuZCBpdCBlaXRoZXIgaGFzIGJlZW4gYWNjZXB0ZWQgb3IgaXMgYmVpbmcgcHJvY2Vzc2VkLjxicj48YnI+PGI+WW91IGNhbid0IHN3aXRjaCB5b3VyIHJldHVybiB0byBhbm90aGVyIHdlYnNpdGUgYXQgdGhpcyB0aW1lLiIsImlzUmVkaXJlY3RUb0xvZ2luIjpmYWxzZX1d

const mapErrorWithId = (idsArray) => {
	let safeAlerts = []
	idsArray.forEach((id) => {
		for (let i = 0; i < messages.length; i++) {
			if (parseInt(messages[i].id) === parseInt(id)) {
				safeAlerts.push(messages[i].content)
			}
		}
	})
	if (safeAlerts.length === 0) safeAlerts.push(messages[0].content)
	return safeAlerts;
}

const mapErrorWithMessage = (alerts) => {
	let safeAlerts = []
	let alertFound = false

	alerts.forEach((alert) => {
		if (alert.title && alert.title !== '') {
			for (let key in mappingTitles) {
				if (alert.title.toLowerCase().includes(key.toLowerCase())) {
					safeAlerts.push(mappingTitles[key])
					alertFound = true
					break
				}
			}
		} else if (alert.message && alert.message !== '') {
			for (let key in mappingMessages) {
				if (alert.message.toLowerCase().includes(key.toLowerCase())) {
					safeAlerts.push(mappingMessages[key])
					alertFound = true
					break
				}
			}
		}
		if (!alertFound) {
			safeAlerts.push(MESSAGE_1)
		}
		alertFound = false
	})
	return safeAlerts
}

export const mapErrorMessages = (alerts) => {
	if (isNumeric(alerts[0])) return mapErrorWithId(alerts)
	else return mapErrorWithMessage(alerts)
};